import { render, staticRenderFns } from "./LandingHeroV2.vue?vue&type=template&id=051c56b6&scoped=true&"
import script from "./LandingHeroV2.vue?vue&type=script&lang=ts&"
export * from "./LandingHeroV2.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHeroV2.vue?vue&type=style&index=0&id=051c56b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c56b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('051c56b6', component.options)
    } else {
      api.reload('051c56b6', component.options)
    }
    module.hot.accept("./LandingHeroV2.vue?vue&type=template&id=051c56b6&scoped=true&", function () {
      api.rerender('051c56b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/LandingHeroV2.vue"
export default component.exports